import React from "react";

import './KeylessModal.css'

export function KeylessModal({ isOpen, animation, img, imgHeight, title, message, actions, imgStyle={}, modalStyle = {} }) {

  const animationStyle = animation ? {
    animation: animation ? `${animation} 0.5s ease-out` : '',
  } : {}

  return isOpen ? (
    <div style={styles.dimmer}>
      <div style={{...styles.modal, ...animationStyle, ...modalStyle }}>
        <div style={styles.content}>
          <img style={{...styles.img, ...imgStyle }} src={img} alt="" height={imgHeight} />
          <h2 style={styles.title}>{title}</h2>
          <p style={styles.message}>{message}</p>
        </div>
        {actions ? <div style={styles.actions}>{actions}</div> : null}
      </div>
    </div>
  ) : null;
}

const styles = {
  dimmer: {
    position: "absolute",
    top: "0",
    height: "100%",
    width: "100%",
    background: "rgba(0, 0, 0, 0.7)",
    transition: "opacity 500ms",
    opacity: "1",
    zIndex: "999",
  },
  modal: {
    position: "relative",
    left: "50%",
    top: "50%",
    transform: "translate(-50%,-50%)",
    width: "80%",
    minWidth: "300px",
    padding: "2rem",
    background: "#fff",
    borderRadius: "15px",
    zIndex: "10",
    textAlign: "center",
    zIndex: "4",

    display: "flex",
    flexDirection: "column",
    maxHeight: "70dvh",
  },
  img: {
    width: "50%",
    maxWidth: "150px",
    marginBottom: "1rem",
  },
  content: {
    flex: "1",
  },
  title: {
    fontWeight: "700",
    fontSize: "22px",
    color: "#666666",
  },
  message: {
    fontSize: "18px",
  },
};
